module.exports = __webpack_public_path__ + "img/voucher-about-popup.5a714214.png";